import { render } from "./DaftarProgramBudgeting.vue?vue&type=template&id=633e8b87"
import script from "./DaftarProgramBudgeting.vue?vue&type=script&lang=js"
export * from "./DaftarProgramBudgeting.vue?vue&type=script&lang=js"

import "./DaftarProgramBudgeting.vue?vue&type=style&index=0&id=633e8b87&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__